import { render, staticRenderFns } from "./FactorForm.vue?vue&type=template&id=850d1722"
import script from "./FactorForm.vue?vue&type=script&lang=js"
export * from "./FactorForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports